import { OctagramMinusIcon } from './OctagramMinusIcon';

/**
 * author: Jeff Anders
 * id FA0E4A6E-0AED-4C67-B4AD-B52CF53C6D92
 * name octagram-minus
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagram-minus.svg
 * tags
 * - Shape 
 */
export const StarburstPlusIcon = OctagramMinusIcon;
export default StarburstPlusIcon